<template>
  <div style="min-height: 60vh; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 28px;">
    <h2 style="margin: 0; font-size: 28px; font-weight: 600; color: #1e293b;">Generate Salary Reports</h2>

    <div style="display: flex; flex-direction: column; align-items: center; gap: 6px;">
      <label style="font-size: 15px; font-weight: 600; color: #475569; text-transform: uppercase; letter-spacing: 0.05em;">Select Date Range</label>
      <date-picker
        v-model="dateRange"
        range
        multi-calendars
        format="dd/MM/yyyy"
        placeholder="dd/MM/yyyy  —  dd/MM/yyyy"
        :enable-time-picker="false"
        style="width: 440px;"
      />
    </div>

    <div style="display: flex; gap: 16px;">
      <button
        style="padding: 13px 36px; background-color: #1d4ed8; color: #fff; border: none; border-radius: 6px; font-size: 16px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 8px;"
        :disabled="loading"
        @click="sendData"
      >
        <span v-if="loading === 'salary'" class="spinner"></span>
        Generate Salary Excel
      </button>
      <button
        style="padding: 13px 36px; background-color: #15803d; color: #fff; border: none; border-radius: 6px; font-size: 16px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 8px;"
        :disabled="loading"
        @click="sendTSSData"
      >
        <span v-if="loading === 'tss'" class="spinner"></span>
        Generate TSS Charges Excel
      </button>
    </div>

    <a ref="downloadLink" style="display: none"></a>
  </div>
</template>


  
<script>
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { storeUtils } from '../utils/store.js'
import { useQualifierStore } from '@/stores/qualifiers.js'
import axios from "axios";
import { useToast } from "vue-toast-notification";
export const apiInstance = axios.create({
  responseType: "json",
  headers: {
    //'Content-Type': 'application/json',
  },
});


const $toast = useToast();
apiInstance.interceptors.request.use(config => {
  const t = storeUtils.getToken();
  if (t) config.headers['Authorization'] = `Bearer ${t}`;
  return config;
});
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      dateRange: null,
      loading: null,
      storeUtils
    };
  },
  computed: {
    startDate() {
      return this.dateRange ? this.dateRange[0] : null;
    },
    finalDate() {
      return this.dateRange ? this.dateRange[1] : null;
    },
  },
  methods: {

   /* async sendData() {
      const qualifierStore = useQualifierStore()
      const formattedStartDate = this.formatDate(this.startDate);
      const formattedFinalDate = this.formatDate(this.finalDate);

      const response = await qualifierStore
        .getSalary(formattedStartDate, formattedFinalDate)
          
      if(response.ok){
        this.$refs.downloadLink.setAttribute("href", response);
        $toast.success(`Download succesfully`);
        this.$refs.downloadLink.click();
      }
      else {
        console.error("Dates have not been selected.");
      }
    },*/

    sendData() {
      const formattedStartDate = this.formatDate(this.startDate);
      const formattedFinalDate = this.formatDate(this.finalDate);
      if (this.startDate && this.finalDate) {
        this.loading = 'salary';
        const url = `${storeUtils.apiAurl}/Qualifiers/EmployeeWageTable?startDate=${formattedStartDate}&finalDate=${formattedFinalDate}`;
        apiInstance
          .get(url)
          .then((result) => {
            if (result.status >= 200 && result.status <= 205) {
              $toast.success(`Download succesfully`);
              this.$refs.downloadLink.setAttribute("href", url);
              this.$refs.downloadLink.click();
            }
          })
          .catch((err) => $toast.error("Error") + err)
          .finally(() => { this.loading = null; });
      } else {
        $toast.warning("Please select a date range first.");
      }
    },
    sendTSSData() {
      const formattedStartDate = this.formatDate(this.startDate);
      const formattedFinalDate = this.formatDate(this.finalDate);
      if (this.startDate && this.finalDate) {
        this.loading = 'tss';
        const url = `${storeUtils.apiAurl}/Qualifiers/TSSTable?startDate=${formattedStartDate}&finalDate=${formattedFinalDate}`;
        apiInstance
          .get(url)
          .then((result) => {
            if (result.status >= 200 && result.status <= 205) {
              $toast.success(`Download succesfully`);
              this.$refs.downloadLink.setAttribute("href", url);
              this.$refs.downloadLink.click();
            }
          })
          .catch((err) => $toast.error("Error") + err)
          .finally(() => { this.loading = null; });
      } else {
        $toast.warning("Please select a date range first.");
      }
    },
    
    formatDate(date) {
      if (!date) return "";
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();
      return mm + "/" + dd + "/" + yyyy; // backend expects MM/dd/yyyy
    },
  },
};
</script>
<style scoped>
.spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.custom-date-picker {
  width: 50px; /* Ajustează lățimea la nevoile tale */
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  outline: none; /* Elimină conturul la focus */
  cursor: pointer; /* Indicator de cursor la hover */
}

/* Stil pentru buton */
button {
  padding: 10px 20px;
  background-color: #008cba;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* Stil pentru buton la hover */
button:hover {
  background-color: #007aa9;
}
</style>
  